import React, { useState, useEffect } from 'react';
import propTypes from 'prop-types';
import { Box, CircularProgress, TableCell, Tooltip, Typography } from '@mui/material';
import { PaginationTable } from './PaginationTable';
import DeleteIcon from '@mui/icons-material/Delete';
import { LoadingButton } from '@mui/lab';
import { renderErrorMessage, renderSuccessMessage } from 'src/lib/toastMessage';
import { axiosPostCall } from 'src/services/apisCall';

const columns = [
  { id: 'plan_id', label: 'Plan ID', minWidth: 70, align: 'center' },
  { id: "user_plan_id", label: "User Plan Id", minWidth: 70, align: 'center' },
  { id: "deduction_type", label: "Deduction Type", minWidth: 70, align: 'center' },
  { id: 'single_part_english', label: 'Single English Char', minWidth: 100, align: 'center' },
  { id: 'single_part_unicode', label: 'Single Unicode Char', minWidth: 100, align: 'center' },
  { id: 'multi_part_english', label: 'Multi English Char', minWidth: 100, align: 'center' },
  { id: 'multi_part_unicode', label: 'Multi Unicode Char', minWidth: 100, align: 'center' },
  { id: 'transactional_sms', label: 'Trans', minWidth: 100, align: 'center' },
  { id: 'promotional_sms', label: 'Promo', minWidth: 100, align: 'center' },
  { id: 'explicit_sms', label: 'Explicit', minWidth: 100, align: 'center' },
  { id: 'implicit_sms', label: 'Implicit', minWidth: 100, align: 'center' },
  { id: 'dlt_sms', label: 'DLT', minWidth: 100, align: 'center' },
  { id: 'create_date', label: 'Create Date', minWidth: 100, align: 'center' },
  { id: 'actions', label: 'Action', minWidth: 80, align: 'center' },
];

export const SmsUserPlantable = ({ assignedPlan = [], user = {}, setForceLoad, loading: tableLoading }) => {

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  // const rows = assignedPlan || [];
  const withPercent = (value, percent) =>
    `${value} (${percent}%)`;
  const rows = (assignedPlan || []).map((row) => ({
    ...row,

    single_part_english: withPercent(
      row.single_part_english_char_limit,
      row.single_part_english_char_percentage
    ),

    single_part_unicode: withPercent(
      row.single_part_unicode_char_limit,
      row.single_part_unicode_char_percentage
    ),

    multi_part_english: withPercent(
      row.multi_part_english_char_limit,
      row.multi_part_english_char_percentage
    ),

    multi_part_unicode: withPercent(
      row.multi_part_unicode_char_limit,
      row.multi_part_unicode_char_percentage
    ),

    transactional_sms: withPercent(
      row.transactional_sms_price,
      row.transactional_sms_price_percentage
    ),

    promotional_sms: withPercent(
      row.promotional_sms_price,
      row.promotional_sms_price_percentage
    ),

    explicit_sms: withPercent(
      row.explicit_sms_price,
      row.explicit_sms_price_percentage
    ),

    implicit_sms: withPercent(
      row.implicit_sms_price,
      row.implicit_sms_price_percentage
    ),

    dlt_sms: withPercent(
      row.dlt_sms_price,
      row.dlt_sms_price_percentage
    ),
  }));


  const handleRemovePlan = async (plan, setLoading) => {
    setLoading(true);
    try {
      const payload = { 
        planId: plan.plan_id,
        actionUserId: user.userId, 
      }
      const { message } = await axiosPostCall("removeSmsUserPlan", payload);
      setForceLoad(true);
      renderSuccessMessage(message);

    } catch (error) {
      console.error("userPlanTable.jsx ,handleRemovePlan ,removeUserPlan api", error);
      renderErrorMessage(error?.message);
    }

    setLoading(false);
  }

  const ActionJsx = ({ id, align, value, row }) => {
    const [removePlanLoading, setRemovePlanLoading] = useState(false);

    return (
      <TableCell
        key={id}
        align={align}
        sx={{
          color: 'grey.400',
          borderBottom: '0.5px dashed',
          borderColor: 'grey.700',
        }}
      >
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <Tooltip title="Remove Plan">
            <LoadingButton
              style={{ width: '30px', minWidth: '30px' }}
              size="small"
              sx={{ color: 'red' }}
              onClick={() => handleRemovePlan(row, setRemovePlanLoading)}
              loading={removePlanLoading}
              loadingIndicator={<CircularProgress style={{ color: 'red' }} size={16} />}
            >
              <DeleteIcon />
            </LoadingButton>
          </Tooltip>
        </Box>
      </TableCell>
    );
  };
  return (
    <Box>
      <Typography id="modal-modal-title" variant="h6" component="h2" sx={{ mb: '-20px' }}>
        Currrent Assigned Plans
      </Typography>
      <PaginationTable
        page={page}
        ActionJsx={ActionJsx}
        setPage={setPage}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}
        loading={tableLoading}
        rows={rows}
        columns={columns}
        maxHeight={680}
        mapKey="plan_id"
      // onRowFieldChange={handleFieldChange}
      />
    </Box>
  );
};

SmsUserPlantable.propTypes = {
  campaignId: propTypes.number,
};